module.exports = __webpack_public_path__ + "img/img30.c2187df8.svg";